import { suvoProcurementCategoryHierarchy } from '@suvo/shared/suvo-tenders';
import type { IFiltersSections } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/filters/interfaces/sections/filters-sections.interface';
import type { ITendersCheckboxItemList } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/filters/interfaces/tenders-info/tenders-checkbox-item-list.interface';
import { ALL_CONTINENTS, CONTINENT_COUNTRIES } from './country-continents';

export const tendersProducts: ITendersCheckboxItemList[] =
  suvoProcurementCategoryHierarchy
    .find(({ name, value }) => value === '01' || name === 'Rail' || name === 'Rail Industry')
    ?.items.map((cat) => ({
      name: cat.name,
      value: `01-${cat.value}`,
      items:
        cat?.items.map((subCat) => ({
          name: subCat.name,
          value: `01-${cat.value}-${subCat.value}`,
        })) ?? [],
    })) ?? [];

const TENDERS_CONTINENT_REGION_ID_MAP: { [x: string]: string } = {
  Africa: '0100',
  Asia: '03',
  Europe: '0500',
  'North America': '0203',
  'South America': '0204',
  Oceania: '0400',
};

const tendersContinents = ALL_CONTINENTS.filter(
  (continent) => TENDERS_CONTINENT_REGION_ID_MAP[continent.name],
).map((continent) => ({
  ...continent,
  value: TENDERS_CONTINENT_REGION_ID_MAP[continent.name],
}));

const childProducts = new Set();
tendersProducts.forEach((p) => {
  childProducts[p.name] = p.items;
});

export const TENDERS_NEW_FILTERS_SECTIONS: IFiltersSections = {
  name: 'tenders',
  shortCode: 'tenders',
  sections: [
    {
      options: [
        {
          filterMethod: 'combined-nested-checkboxes',
          filterMethodConfig: {
            title: 'Location',
            showChildrenLabel: 'Show countries',
            enableShowChildren: true,
            parentData: tendersContinents,
            parentKeyName: 'regionIds',
            parentLabel: 'continent',
            childData: CONTINENT_COUNTRIES,
            childKeyName: 'countryCodes',
            locationMode: 'countries-only',
            countriesKeyName: 'countryCodes',
            toggleGroupParentKey: 'value',
            toggleGroupChildKey: 'value',
            optionsColumns: 3,
          },
          filterPropertyKeys: ['regionIds', 'countryCodes'],
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'combined-nested-checkboxes',
          filterMethodConfig: {
            title: 'Products',
            showChildrenLabel: 'Show products',
            enableShowChildren: true,
            parentData: tendersProducts,
            parentKeyName: 'categories',
            parentLabel: 'Product category',
            childData: childProducts,
            childKeyName: 'categories',
            toggleGroupParentKey: 'value',
            toggleGroupChildKey: 'value',
          },
          filterPropertyKeys: ['categories', 'categories'],
        },
      ],
    },
    {
      options: [
        {
          filterMethod: 'keywords',
          filterMethodConfig: {
            title: 'Keywords',
            label: 'Any keywords',
          },
          filterPropertyKeys: ['search'],
        },
      ],
    },
  ],
};
